import {
    ChangeDetectorRef,
    Component,
    ElementRef,
    EventEmitter,
    HostBinding,
    Input,
    Output,
    ViewChild
} from "@angular/core";
import {FedeltaImageData} from "@fedelta-pos/data-client";
import {SelectorType} from "../../../../inputs/selector-control/selector";
import {TouchableDirective} from "../../../../ui-elements/touchable.directive";
import {MenuModel} from "../../../../menu/menu.model";
import {MenuItemImageOverlay} from "../../../../menu/menu-entity.model";

export enum OrderItemOptionLayout {
    HORIZONTAL,
    VERTICAL,
}

export enum OrderItemOptionSize {
    DESKTOP,
    MOBILE,
}

@Component({
    selector: "woa-order-item-option-control",
    templateUrl: "./order-item-option-control.component.html"
})
export class OrderItemOptionControlComponent {
    MenuItemImageOverlay = MenuItemImageOverlay;

    @Input() image: FedeltaImageData;
    @Input() imageOverlay: MenuItemImageOverlay;
    @Input() controlType: SelectorType = SelectorType.RADIO;
    @Input() layout: OrderItemOptionLayout = OrderItemOptionLayout.HORIZONTAL;
    @Input() size: OrderItemOptionSize = OrderItemOptionSize.DESKTOP;
    @Input() @HostBinding("class.compact") compact: boolean = false;
    @Input() @HostBinding("class.aligned") aligned: boolean = false;
    @Input() title: string;
    @Input() price: number;
    @Input() guestPrice: number;
    @Input() @HostBinding("class.with-image") showImage: boolean = true;
    @Input() @HostBinding("class.with-control") showControl: boolean = true;
    @Input() disableControl: boolean = false;
    @Input() hidePrice: boolean = false;
    @Input() showEmptyPrice: boolean = false;
    @Input() showPriceSign: boolean = true;
    @Input() @HostBinding("class.unavailable") unavailable: boolean = false;
    @Input() selected: boolean = false;

    @Output() onSelect: EventEmitter<void> = new EventEmitter<void>();

    @ViewChild(TouchableDirective) public touchable: TouchableDirective;
    @ViewChild("content", {read: ElementRef}) public content: ElementRef;

    @HostBinding("class.horizontal") get isHorizontalLayout(): boolean {
        return this.layout === OrderItemOptionLayout.HORIZONTAL;
    }
    @HostBinding("class.vertical") get isVerticalLayout(): boolean {
        return this.layout === OrderItemOptionLayout.VERTICAL;
    }
    @HostBinding("class.desktop-size") get idDesktopSize(): boolean {
        return this.size === OrderItemOptionSize.DESKTOP;
    }
    @HostBinding("class.mobile-size") get isMobileSize(): boolean {
        return this.size === OrderItemOptionSize.MOBILE;
    }
    @HostBinding("class.with-content") get hasContent(): boolean {
        return this.content && this.content.nativeElement.children.length > 0;
    }

    constructor(public menuModel: MenuModel,
                public changeDetectorRef: ChangeDetectorRef) {
    }

    get priceAbs(): number {
        return this.price ? Math.abs(this.price) : this.guestPrice ? 0 : undefined;
    }

    get priceSign(): string {
        return !this.price ? "" : this.price < 0 ? "-" : this.showPriceSign ? "+" : "";
    }

    get guestPriceAbs(): number {
        return this.guestPrice ? Math.abs(this.guestPrice) : undefined;
    }

    get guestPriceSign(): string {
        return !this.guestPrice ? "" : this.guestPrice < 0 ? "-" : this.showPriceSign ? "+" : "";
    }

    optionSelected(event: MouseEvent): void {
        event.stopPropagation();
        if (this.controlType === SelectorType.RADIO && this.selected) {
            event.preventDefault();
            return;
        }
        this.onSelect.emit();
    }
}



// WEBPACK FOOTER //
// ./src/app/order/order-item/order-item-options-panel/order-item-option-control/order-item-option-control.component.ts